document.addEventListener("DOMContentLoaded", function () {

    function random(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function getOrSet(key, generator) {
        let val = sessionStorage.getItem(key);
        if (val === null) {
            val = generator();
            sessionStorage.setItem(key, val);
        }
        return parseInt(val, 10);
    }

    const viewers = document.getElementById("viewer-count");
    const sold = document.getElementById("sold-count");
    const stock = document.getElementById("stock-count");

    const toast = document.getElementById("purchase-toast");
    const toastTitle = document.getElementById("toast-title");

    if (!viewers || !sold || !stock) return;

    let viewerCount = getOrSet("z_viewer", () => random(18, 31));
    let soldCount   = getOrSet("z_sold",   () => random(12, 24));
    let stockCount  = getOrSet("z_stock",  () => random(6, 12));

    viewers.textContent = viewerCount;
    sold.textContent = soldCount;
    stock.textContent = stockCount;

    function flash(el) {
        el.classList.add("z-live-flash");
        setTimeout(function () {
            el.classList.remove("z-live-flash");
        }, 400);
    }

    setInterval(function () {

        viewerCount += random(-2, 2);
        viewerCount = Math.max(16, Math.min(34, viewerCount));

        sessionStorage.setItem("z_viewer", viewerCount);
        viewers.textContent = viewerCount;

        flash(viewers);

    }, 25000);

    setInterval(function () {

        soldCount += random(0, 1);

        if (soldCount > 40) {
            soldCount = random(15, 20);
        }

        sessionStorage.setItem("z_sold", soldCount);
        sold.textContent = soldCount;

        flash(sold);

    }, 180000);

    setInterval(function () {

        stockCount--;

        if (stockCount < 4) {
            stockCount = random(8, 12);
        }

        sessionStorage.setItem("z_stock", stockCount);
        stock.textContent = stockCount;

        flash(stock);

    }, 150000);

    const names = [
        "Emily", "James", "Sarah", "Michael", "Emma",
        "David", "Olivia", "Daniel", "Sophie", "Ryan",
        "Grace", "Andrew", "Chloe", "Jack", "Hannah"
    ];

    const cities = [
        "New York",
        "Los Angeles",
        "Chicago",
        "London",
        "Manchester",
        "Toronto",
        "Austin",
        "Seattle"
    ];

    function showToast() {

        if (!toast || !toastTitle) return;

        const person = names[random(0, names.length - 1)];
        const city = cities[random(0, cities.length - 1)];
        const mins = random(2, 15);

        toastTitle.innerHTML =
            "<strong>" + person + "</strong> from " + city +
            "<br>purchased this item " + mins + " min ago";

        toast.classList.add("show");

        setTimeout(function () {
            toast.classList.remove("show");
        }, 5000);

    }

    setTimeout(showToast, 8000);
    setInterval(showToast, 45000);

});